import React, { useState, useEffect, useRef } from "react";
import {
    Paper,
    Typography,
    IconButton,
    Button,
    Divider,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import sound from "./alaram.mp3";
import { Link } from "react-router-dom";
const NotificationContext = () => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const previousOrderIds = useRef([]); // 🔹 to track previously seen orders
    const notificationSound = new Audio(sound);
    const isMobile = window.innerWidth <= 768;
    // ✅ Fetch order & payment notifications
    const fetchNotifications = async () => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");
            if (!vendorId || !token) return;

            const response = await axios.get(
                `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
                {
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const orders = response.data || [];

            // ✅ Filter only "PENDING" orders and exclude "TABLE_DINE_IN"
            const filteredOrders = orders.filter(
                (order) =>
                    order.status?.toUpperCase() === "PENDING" &&
                    order.orderType !== "TABLE_DINE_IN"
            );

            // ✅ Format filtered order notifications
            const formatted = filteredOrders.map((order) => ({
                id: order.orderId,
                message: `🧾 Order #${order.orderId} | Status: ${order.status}`,
                details: `📅 ${order.date} 🕒 ${order.time}\n🍽️ Items: ${order.order?.map((item) => item.dishName).join(", ") || "No items"
                    }`,
                path: "/foodordermanagment",
            }));

            // ✅ Detect NEW orders (play sound only for new pending ones)
            const currentOrderIds = formatted.map((o) => o.id);
            const newOrders = currentOrderIds.filter(
                (id) => !previousOrderIds.current.includes(id)
            );

            if (newOrders.length > 0) {
                notificationSound.play().catch((err) =>
                    console.warn("Sound playback blocked by browser:", err)
                );
            }

            previousOrderIds.current = currentOrderIds; // update for next check

            // ✅ Add optional static notifications
            const staticNotifications = [
                { id: 1001, message: "⚠️ Subscription expiring soon!", path: "/subscriptionrenewal" },
                { id: 1002, message: "🎊 Diwali special offers available!", path: "/offers" },
                { id: 1003, message: "💰 New payment received today.", path: "/payment" },
            ];

            setNotifications([...formatted, ...staticNotifications]);
        } catch (error) {
            console.error("Error fetching notifications:", error);

            // fallback notifications
            setNotifications([
                { id: 1, message: "🎉 Welcome to MAAMAA'S!", path: "/welcome" },
                { id: 2, message: "✅ No new pending orders found.", path: "/orders" },
            ]);
        }
    };

    useEffect(() => {
        fetchNotifications();
        const interval = setInterval(fetchNotifications, 60000); // refresh every 1 minute
        return () => clearInterval(interval);
    }, []);

    const handleNotificationClick = (path) => navigate(path);

    const handleCloseNotification = (id) => {
        setNotifications((prev) => prev.filter((note) => note.id !== id));
    };

    if (notifications.length === 0) return null;

    return (
        <div>
            <p className="breadcrumb maamaas-home-bredcum" style={{
                position: "fixed",
                top: isMobile ? "50px" : "80px",
                left: isMobile ? "5px" : "235px",
                width: "100%",
                backgroundColor: "#fff",
                zIndex: 1000,
                padding: "10px 0",
                fontSize: isMobile ? "14px" : "18px",
                fontWeight: isMobile ? "normal" : "bold",
                textAlign: "center",
                margin: 0,
            }}>
                {/* <Link style={{
                    color: "purple",
                    fontWeight: "bold",
                    textDecoration: "none",
                }} to="/Newmainlandingpage">Home</Link> */}
                {/* <span className="separator"> &gt; </span> */}
                <Link
                    style={{
                        color: "purple",
                        fontWeight: "bold",
                        textDecoration: "none",
                    }}
                >
                    Notifications
                </Link>
            </p>

            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 3000,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    pointerEvents: "none", // ✅ allow clicks to pass through background  
                    scrollbarWidth: "none",
                }}
            >
                <Box
                    sx={{
                        width: "80%",
                        maxWidth: "900px",
                        scrollbarWidth: "none",
                        height: "80vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 3,
                        padding: "20px",
                        borderRadius: "12px",
                        marginTop: "110px",
                        pointerEvents: "auto", // ✅ keep notification cards clickable
                    }}
                >
                    {notifications.map((note, index) => (
                        <Paper
                            key={note.id}
                            elevation={8}
                            sx={{
                                width: "100%",
                                padding: "24px",
                                borderRadius: "14px",
                                borderLeft: "8px solid #7B2CBF",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                                animation: `slideUp 0.5s ease ${index * 0.15}s`,
                                position: "relative",
                                transition: "transform 0.3s ease",
                                "&:hover": { transform: "scale(1.02)" },
                            }}
                        >
                            <IconButton
                                size="small"
                                onClick={() => handleCloseNotification(note.id)}
                                sx={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                    color: "#777",
                                    "&:hover": { color: "#000" },
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>

                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: "bold",
                                    color: "#4B0082",
                                    marginBottom: "8px",
                                }}
                            >
                                Notification
                            </Typography>

                            <Divider sx={{ marginBottom: "14px" }} />

                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#333",
                                    marginBottom: "16px",
                                    lineHeight: 1.6,
                                    fontSize: "16px",
                                    whiteSpace: "pre-line",
                                }}
                            >
                                {note.message}
                                {note.details ? `\n\n${note.details}` : ""}
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => handleNotificationClick(note.path)}
                                sx={{
                                    background: "linear-gradient(90deg, #7B2CBF, #9D4EDD)",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    borderRadius: "10px",
                                    padding: "8px 18px",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #6A1FBF, #8A2BE2)",
                                    },
                                }}
                            >
                                View
                            </Button>
                        </Paper>
                    ))}
                </Box>

                {/* Animations & scrollbar style */}
                <style>
                    {`
                    @keyframes slideUp {
                        from { transform: translateY(40px); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                    ::-webkit-scrollbar {
                        width: 10px;
                    }
                    ::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 10px;
                    }
                    ::-webkit-scrollbar-thumb {
                        background: #b085f5;
                        border-radius: 10px;
                    }
                    ::-webkit-scrollbar-thumb:hover {
                        background: #7b2cbf;
                    }
                `}
                </style>
            </Box>
        </div >
    );
};

export default NotificationContext;
